class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.utils = new Utils();
    this.button = this.querySelector("button");

    this.bufferedPage = {
      key: "",
      value: "",
    };
    this.gridItemSelector = this.dataset.gridItem || "li[data-product-item]";
    this.gridSelector = this.dataset.grid || "[data-product-grid]";
    this.gridElem = document.querySelector(this.gridSelector);
  }


  connectedCallback() {
    this.handleCurrentPagination();
    this.listener();

    subscribe("facets-update", () => {
      this.bufferedPage = {
        key: "",
        value: "",
      };
    });
    this.createBufferedPage(2);
    history.scrollRestoration = "auto";
  }

  listener() {
    this.button?.addEventListener("click", async (e) => {
      this.handleAction();
    });
  }

  handleAction() {
    const url = new URL(location);
    const curPage = parseInt(url.searchParams.get("pagination")) || 1;
    url.searchParams.set("pagination", curPage + 1);
    history.pushState(null, null, url.toString());
    this.renderContent();
    this.createBufferedPage(curPage + 2);
  }

  async createBufferedPage(bufferPage) {
    const url = new URL(location);
    url.searchParams.set("page", bufferPage);
    const response = await fetch(url);
    this.bufferedPage.key = bufferPage;
    this.bufferedPage.value = await response.text();
  }

  getCurrentPage() {
    const url = new URL(window.location);
    return parseInt(url.searchParams.get("pagination"));
  }

  async handleCurrentPagination() {
    try {
      this.parentElement.toggleAttribute("loading", !0);
      const page = this.getCurrentPage();
      if (page) {
        for (let i = 2; i <= page; i++) {
          const url = new URL(window.location);
          url.searchParams.set("pagination", parseInt(i));
          history.pushState(null, null, url.toString());
          await this.renderContent();
        }
      }
    } catch (err) {
      return this.parentElement.toggleAttribute("loading", !1), !1;
    }
  }

  async renderContent() {
    this.classList.add("tw-hidden");
    this.parentElement.classList.add("loading");

    const page = this.getCurrentPage();

    let html;

    if (this.bufferedPage.key === page) {
      html = this.bufferedPage.value;
    } else {
      const response = await fetch(
        window.location.href.replace("pagination", "page")
      );
      html = await response.text();
    }

    const doc = new DOMParser().parseFromString(html, "text/html");
    const fragment = document.createDocumentFragment();

    const newGrid = doc.querySelector(this.gridSelector);
    const newGridItems = newGrid?.querySelectorAll(this.gridItemSelector) || [];


    newGridItems.forEach((item) => {
      fragment.appendChild(item);
    });

    this.gridElem.appendChild(fragment);

    const totalProducts = this.gridElem.querySelectorAll(
      this.gridItemSelector
    ).length;
    this.querySelector("[data-current-total-products]").innerHTML =
      totalProducts;

    const totalPages = this.getAttribute("data-total-pages");
    this.classList.toggle("tw-hidden", page >= parseInt(totalPages));

    this.parentElement.classList.remove("loading");
  }
}

customElements.define("load-more", LoadMore);
